import { useTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui';
import { useUserUnlockMutation } from '../hooks/useUserUnlockMutation';

interface UserUnlockButtonProps {
  userId: string;
  locked: boolean;
  onSuccess?: () => void;
}

export const UserUnlockButton = ({ userId, locked, onSuccess }: UserUnlockButtonProps) => {
  const { t } = useTranslation('common');
  const mutation = useUserUnlockMutation();

  if (!locked) return null;

  const handleUnlock = async () => {
    await mutation.mutateAsync(userId);
    onSuccess?.();
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => void handleUnlock()}
      disabled={mutation.isPending}
    >
      {t('users.actions.unlock')}
    </Button>
  );
};
